if (!customElements.get('installments-calculator')) {
  customElements.define(
    'installments-calculator',
    class InstallmentsCalculator extends HTMLElement {
      connectedCallback() {
        this.summary = this.querySelector('.installments__summary');
        this.options = this.querySelector('.installments__options');
        if (!this.summary || !this.options) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.summary.addEventListener('click', () => this.toggle(), { signal });
        this.options.addEventListener(
          'click',
          (event) => {
            const option = event.target.closest('.installments__option');
            if (option) this.select(option.dataset.index);
          },
          { signal }
        );
        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Escape' || !this.isOpen) return;
            event.stopPropagation();
            this.toggle(false);
            this.summary.focus();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get isOpen() {
        return this.summary.getAttribute('aria-expanded') === 'true';
      }

      toggle(open = !this.isOpen) {
        this.summary.setAttribute('aria-expanded', String(open));
        this.options.hidden = !open;
      }

      select(index) {
        this.querySelectorAll('.installments__text').forEach((text) => {
          text.hidden = text.dataset.index !== index;
        });
        this.options.querySelectorAll('.installments__option').forEach((option) => {
          option.setAttribute('aria-pressed', String(option.dataset.index === index));
        });
        this.toggle(false);
        this.summary.focus();
      }
    }
  );
}
